import styled from "styled-components";
import { Flex } from "./Flex";

const StyledLayout = styled.div`
    height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: ${({ direction}) => direction};
    overflow-y: hidden;
`;

const StyledSider = styled(Flex).attrs({
    direction: 'column',
    justify: 'space-between',
    height: "100%"
})`
    width: ${({collapsed}) => collapsed ? '80px' : '240px'};
    min-width: ${({collapsed}) => collapsed ? '80px' : '240px'};
    padding: 14px 0px 20px;
    background: var(--sp-text-color);

    transition: width 1s;
`;

const StyledScrollableMenuWrapper = styled.div`
    flex: 1;
    height: 100%;
    overflow: hidden;
`;

const StyledScrollableMenu = styled(Flex).attrs({
    direction: 'column',
    justify: 'space-between',
    height: "100%"
})`
    height: calc(100% + 17px);
    width: calc(100% + 17px);
    overflow: scroll;
`;

const StyledContent = styled(Flex).attrs(props => ({
    direction: "column",
    height: "calc(100% - 64px)",
    background: props.background ? props.background : "#F0F4FB",
    padding: { top: "24px", right: "40px", bottom: "33px", left: "42px" }
}))`
    min-width: 1126px;
`;

const StyledFrontPanel = styled.div`
    position: fixed;
    bottom: 0;
    right: 0;
    padding: 0px 24px 24px 0px;

    transition: transform .6s ease-in-out;
    animation: toast-in-right .7s;
    z-index: 99;

    & > div:not(:last-child) {
        margin-bottom: 8px;
    }
`;

const Sider = (props) => <StyledSider {...props} />

const Content = (props) => <StyledContent {...props} />

const Layout = (props) => <StyledLayout {...props} />

const ScrollableMenu = (props) => (
    <StyledScrollableMenuWrapper>
        <StyledScrollableMenu>
            {props.children}
        </StyledScrollableMenu>
    </StyledScrollableMenuWrapper>
);

const Front = (props) => <StyledFrontPanel {...props} />

export { Layout };
export { Sider };
export { Content };
export { Front };
export { ScrollableMenu };